<script setup lang="ts">
import FinestButton from '@/components/FinestButton.vue'
import FinestListItem from '@/components/FinestListItem.vue'
import { useI18n } from 'vue-i18n'

export interface LoanListEntry {
  key: string
  title: string
  subtitle: string
}

withDefaults(
  defineProps<{
    entries: LoanListEntry[]
    selected: string
    addLabel?: string
  }>(),
  {
    addLabel: undefined,
  },
)

const emit = defineEmits<{
  select: [key: string]
  add: []
}>()

const { t } = useI18n({ useScope: 'local' })
</script>

<template>
  <div class="flex flex-col gap-2">
    <FinestListItem
      v-for="entry in entries"
      :key="entry.key"
      :label="entry.title"
      :sublabel="entry.subtitle"
      :selected="entry.key === selected"
      @click="emit('select', entry.key)" />

    <FinestButton
      class="mt-1 w-full justify-start border-dashed"
      variant="secondary"
      icon="pi pi-plus"
      :label="addLabel ?? t('add')"
      @click="emit('add')" />
  </div>
</template>

<i18n lang="json">
{
  "de": {
    "add": "Finanzierung hinzufügen"
  },
  "en": {
    "add": "Add financing"
  }
}
</i18n>
